<template>
  <div
        class="infoTextWrapper"
        :class="domain"
      >
        <div v-if="infoTextAB" class="mainInfoText">
          {{ $t($i18n.locale + '.keys.premiumPlans.processPayments.mainInfoText') }}
        </div>
        <div v-if="infoTextAB" class="showInfoTextBtn" @click="toggleInfoText" ref="showInfoTextBtn" >
          <span>{{ $t($i18n.locale + '.keys.premiumPlans.processPayments.showInfoTextBtn') }}</span><i class="fa fa-caret-right"></i>
        </div>
        <div class="subInfoText" v-if="showAdditionalInfoText || !infoTextAB">
          <span
            v-if="this.getActivePlan.plansPrice.discount && this.getActivePlan.plansPrice.initialPrice"
            v-html="$t($i18n.locale +'.keys.premiumPlans.processPayments.thisOfferFullPromotion',
                {
                  duration: this.infoTextDuration,
                  fullPrice: this.getActivePlan.plansPrice.currencySign + this.getActivePlan.plansPrice.fullPrice.replace('.', ','),
                  initialFullPrice: this.getActivePlan.plansPrice.currencySign + this.getActivePlan.plansPrice.initialFullPrice.replace('.', ','),
                  productName: fullDomain,
                  supportEmail: $store.getters.supportEmail,
                  descriptorText: $store.getters.getDescriptorText,
                })"
          ></span>
          <span
          v-else
          v-html="$t($i18n.locale +'.keys.premiumPlans.processPayments.thisOfferFull',
                {
                  duration: this.infoTextDuration,
                  fullPrice: this.getActivePlan.plansPrice.currencySign + this.getActivePlan.plansPrice.fullPrice.replace('.', ','),
                  productName: fullDomain,
                  supportEmail: $store.getters.supportEmail,
                  descriptorText: $store.getters.getDescriptorText,
                })"
          ></span>
        </div>
      </div>
</template>

<script>

import { mapGetters } from "vuex";

export default {
  name: 'MobilePaymentTerms',
  data(){
    return {
      showAdditionalInfoText: false,
    }
  },
  props: {
    domain: {
      type: String,
      required: false,
      default: window.domain
    }
  },
  computed: {
    ...mapGetters(["selectedLanguage","getActivePlan"]),
    
    infoTextAB: function(){
      
      if(this.$store.getters.user.affiliate_id) return true;
      else return false;

    },
    infoTextDuration: function(){
      return this.getActivePlan.plansInfoBody.headlinePeriod || '';
    },
    
    fullDomain: function(){
      var finalUrl = host + '.' + domain;
      if(domain == 'uk') finalUrl = host + '.co.uk';
      else if(domain == 'nz') finalUrl = host +  '.co.nz';
      else if(domain == 'za') finalUrl = host +  '.co.za';
      else if(domain == 'au') finalUrl = host +  '.com.au';
      
      //return host + tld
      return finalUrl;
    }
  },
  methods: {
    toggleInfoText($event) {
      console.log('toggleInfoText', $event)
      this.$refs.showInfoTextBtn.remove();
      this.showAdditionalInfoText = !this.showAdditionalInfoText;
    },
  }
}
</script>

<style scoped lang="scss">
  .infoTextWrapper {
    margin-top: 150px;
    font-size: 0.8em;
    margin-inline: 15px;
    .showInfoTextBtn {
        margin: 5px 0;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
  }

</style>